import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import GatewayManagementComponent from './GatewayManagementComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { getModel } from './selectors';
import * as actions from './actions';
import './style.scss';
import { LeftNavLayout } from './LeftNavLayout';
import { IconBroadcast, IconEvents } from 'svgIcons/MotionPortalIcons';
import { GatewayEvents } from './GatewayEvents';
import { routes } from 'routes';
import { getGatewayManagementMenus } from './helpers';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';
import useUserCapability from 'sharedHooks/useUserCapability';

const GatewayManagementContainer = (props) => {
    const { t: translate } = useTranslation();
    const userCapability = useUserCapability();
    const gatewayAdminReadView = userCapability?.hasGatewayAdminReadView?.() === true;
    const gatewayAdminView = userCapability?.hasGatewayAdminViewCapability?.() === true;
    const {
        generalFilterLoadingStatuses,
    } = props.model;

    const navigationItems = getGatewayManagementMenus(
        translate,
        routes,
        IconBroadcast,
        IconEvents,
        GatewayManagementComponent,
        GatewayEvents,
        { props, gatewayAdminReadView, gatewayAdminView }
    );

    useEffect(() => {
        return () => {
            props.actions.clearStore();
            props.actions.clearDriveApplications();
        };
    }, []);

    return (
        <LoadingStatusWrapper loadingStatus={[...generalFilterLoadingStatuses]}>
            <LeftNavLayout
                navigationItems={navigationItems}
                defaultRoute={routes.GatewayManagementGateways}
                basePath={routes.ToolsGatewayManagement}
            />
        </LoadingStatusWrapper>
    );
};

GatewayManagementContainer.propTypes = {
    model: PropTypes.shape({
        generalFilterLoadingStatuses: PropTypes.array
    }),
    actions: PropTypes.shape({
        clearStore: PropTypes.func
    })
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const GatewayManagementContainerWithErrorBoundaryTrigger = withErrorBoundaryTrigger(GatewayManagementContainer);

const GatewayManagementContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(GatewayManagementContainerWithErrorBoundaryTrigger);

export default React.memo(GatewayManagementContainerConn);
